module.exports = __webpack_public_path__ + "img/SOKAL-SRS-112921-Telluride-Established.41b9b66b.jpeg";